import { styled } from '@material-ui/core';

export const Stack = styled('div')({ display: 'flex', flexDirection: 'column' });
export const HStack = styled('div')({ display: 'flex', alignItems: 'center' });
export const VStack = styled('div')({ display: 'flex', flexDirection: 'column' });
export const Wrap = styled('div')({ display: 'flex', flexWrap: 'wrap' });
export const VScroll = styled(VStack)({ position: 'relative', flex: 1, overflowY: 'auto' });
